// extracted by mini-css-extract-plugin
module.exports = {"controlsWrapper":"styles_controlsWrapper__3ksQQ","pagination":"styles_pagination__3J4Ii","button":"styles_button__-ke-a","exitBtn":"styles_exitBtn__2AuUk"};